import { render, staticRenderFns } from "./GroovyScript.vue?vue&type=template&id=dc46f8ee&scoped=true&"
import script from "./GroovyScript.vue?vue&type=script&lang=js&"
export * from "./GroovyScript.vue?vue&type=script&lang=js&"
import style0 from "./GroovyScript.vue?vue&type=style&index=0&id=dc46f8ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc46f8ee",
  null
  
)

export default component.exports